import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Card, LockIcon, RadioFilledIcon, RadioIcon, SubscriptionIcon } from '@utilities';

import SubscriptionOverview from '../../../../../../../../components/SubscriptionOverview';

import styles from './_index.module.scss';

const PlanCard = ({ isSelected, onClick, subscription }) => {
  const remainingCompletes = subscription?.currentPeriod?.remainingCompletes ?? 0;

  const isDisabled = remainingCompletes <= 0;

  return (
    <Card
      className={classNames(styles['plan-card'], {
        [styles['is-disabled']]: isDisabled,
        [styles['is-selected']]: isSelected,
      })}
      onClick={isDisabled ? undefined : onClick}
      padding="large"
    >
      <div className={styles['plan-card-content']}>
        <div className={styles['plan-card-title-row']}>
          {isDisabled ? (
            <span className={styles['plan-card-lock-icon']}>
              <LockIcon />
            </span>
          ) : (
            <span className={styles['plan-card-radio-icon']}>
              {isSelected ? <RadioFilledIcon /> : <RadioIcon />}
            </span>
          )}

          <h3 className={styles['plan-card-title']}>Use Your Plan</h3>
          <span className={styles['plan-card-icon']}>
            <SubscriptionIcon />
          </span>
        </div>
        <SubscriptionOverview subscription={subscription} />
      </div>
    </Card>
  );
};

PlanCard.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  subscription: PropTypes.shape({
    currentPeriod: PropTypes.shape({
      endDate: PropTypes.string.isRequired,
      remainingCompletes: PropTypes.number,
    }),
    monthlyCompletesTotal: PropTypes.number,
    monthlyCompletesUsed: PropTypes.number,
    type: PropTypes.string.isRequired,
  }).isRequired,
};

export default PlanCard;
